import React, {useEffect, useState, useRef, useCallback} from "react";
import { Form, Row, Col} from 'antd';
import {ROW_GUTTER} from "../../../constants/ThemeConstant";
import Card from "antd/es/card";
import utils from "../../../utils";
import { useHistory } from "react-router-dom";
import {fieldChanged} from "../../../services/actions/Form";
import { connect } from "react-redux";
import Button from "antd/es/button";
import { useMemo } from "react";
import { useIntl } from 'react-intl';
const styleFooter = {
  position: 'absolute',
  bottom: 0,
  width: '100%',
  borderTop: '1px solid #e8e8e8',
  padding: '10px 16px',
  textAlign: 'right',
  left: 0,
  background: '#fff',
  borderRadius: '0 0 4px 4px',
}

const FormActions = (({title, fields, buttons, fieldChanged, changed, selectedRow, save, removeLine, onClose, visible}) => {
  const intl = useIntl();
  const [firstTime, setFirstTime] = useState(0)
  let history = useHistory();

  const form = Form.useForm()[0];

  const formDebounceTimer = useRef(null);
  const handleFormChange = useCallback(() => {
    if (formDebounceTimer.current) {
      clearTimeout(formDebounceTimer.current);
    }
    formDebounceTimer.current = setTimeout(() => {
      fieldChanged();
    }, 300);
  }, [fieldChanged]);


  useEffect(() => {
    form.resetFields();
    if(selectedRow)
      form.setFieldsValue(utils.parseValueToField(selectedRow, fields))
    setFirstTime(firstTime + 1)
    fieldChanged()
  }, [selectedRow, visible])

  return (
    <div>
    <Form
      name="basicInformation"
      layout="vertical"
      form={form}
      autoComplete="off"
      // onFinishFailed={onFinishFailed}
      onChange={handleFormChange}
    >
      <Card title={title}>
        <div className="mt-4">
          <Row>
            <Col xs={24} sm={24} md={24} lg={24}>
              <Row gutter={ROW_GUTTER}>
                {fields?.map((field) => (
                  <RenderField key={field.name || field.label} field={field} form={form} firstTime={firstTime} changed={field.needRefresh ? changed : 0} fieldChanged={fieldChanged}/>
                ))}
              </Row>
              <div>
                {buttons?.map((button, idx) => (
                  <React.Fragment key={idx}>
                    {button.getComponent(form, history)}
                  </React.Fragment>
                ))}
              </div>
            </Col>
          </Row>
        </div>
      </Card>
    </Form>

      <div
        style={styleFooter}
      >
        <Button  type="primary" danger onClick={
          () => {removeLine(selectedRow?.key);onClose();}
        }
                style={{
            float: "left",
          }}
        >
          {intl.formatMessage({ id: 'table.form.delete' })}
        </Button>
        <Button onClick={onClose}
                style={{
            marginRight: 8,
          }}
        >
          {intl.formatMessage({ id: 'table.form.cancel' })}
        </Button>
        <Button type="primary"
          onClick={() => {
            save({key: selectedRow?.key, ...form.getFieldsValue()});
            onClose();
          }}>
          {intl.formatMessage({ id: 'table.form.save' })}
        </Button>
      </div>
    </div>
  );
});

const RenderField = React.memo(({field, form, firstTime, changed, fieldChanged}) => {
  //Necesito actualizar la primera vez que entra en la columna para que el file sepa que tiene cambia el fichero
  const isFileType = field.type === 'file';
  // No incluir 'changed' en dependencias para evitar RECREAR el componente
  const dependencies = isFileType ? [field, firstTime] : [field];
  const FieldComponent = useMemo(() => field.getComponent(form, fieldChanged), dependencies);

  return <FieldComponent/>
}, (prevProps, nextProps) => {
  // Retornar true = NO re-renderizar, false = SÍ re-renderizar

  // Siempre re-renderizar si field o firstTime cambiaron
  if (prevProps.field !== nextProps.field || prevProps.firstTime !== nextProps.firstTime) {
    return false;
  }

  // Para campos con needRefresh, permitir re-render cuando changed cambia
  // Esto permite que FieldBase re-evalúe condiciones sin recrear el componente
  if (prevProps.changed !== nextProps.changed && nextProps.field.needRefresh) {
    return false;
  }

  // En todos los demás casos, no re-renderizar
  return true;
});



const mapStateToProps = (state, ownProps) => ({
  changed: state.form.fieldChanged,
  selectedRow: state.form.selectedFormRow
})

export const DrawerForm = connect(mapStateToProps, { fieldChanged })(FormActions)
